import { render, staticRenderFns } from "./RestaurantDetails.vue?vue&type=template&id=30f2df8a&scoped=true&"
import script from "./RestaurantDetails.vue?vue&type=script&lang=js&"
export * from "./RestaurantDetails.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantDetails.vue?vue&type=style&index=0&id=30f2df8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f2df8a",
  null
  
)

export default component.exports